import { render, staticRenderFns } from "./AssignGroup.vue?vue&type=template&id=5f841f28&"
import script from "./AssignGroup.vue?vue&type=script&lang=js&"
export * from "./AssignGroup.vue?vue&type=script&lang=js&"
import style0 from "./AssignGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports